import { CONTACT_EMAIL, WEB3_TT_COM } from '../../constants'
import { SingleInput } from '../../components';
import { CoinPipe } from './CoinPipe';
import { LottieLoader } from './LottieLoader';
import { PlatformsIcons } from './PlatformsIcons';
import { InvestorsLogos } from './InvestorsLogos';
import { Container } from 'react-bootstrap';
import './LandingPage.scss';

import { getLocale, getBoldTexts } from '../../helpers/localization'
import { subscribeUserEmail } from '../../helpers'

// landing page images
import CoinImage from '../../assets/images/landing-page/big-coin.svg'
import MeetTheBuildersImage from '../../assets/images/landing-page/meet-builders.svg'
import LaunchPartnersImage from '../../assets/images/landing-page/launch-partners.svg'
import BuildCampusImage from '../../assets/images/landing-page/build-campus.svg'
import CommunityCenterImage from '../../assets/images/landing-page/community-center.svg'

// logo sources
import { AnimocaLogo, GemsLogo, MocaverseLogo, SandboxLogo, TinyLogo, HighstreetLogo } from '../../assets/logos/partners-plain'

// lotties
import protocolMachine from '../../assets/lotties/protocol-machine.json'
import tinytapCampus from '../../assets/lotties/TinyTap-campus.json'
import nftHologram from '../../assets/lotties/nft-hologram.json'
import mocaversePortal from '../../assets/lotties/mocaverse-portal.json'
import booksFaire from '../../assets/lotties/books-faire.json'
import gemsCampus from '../../assets/lotties/gems-campus.json'
import tokenMachine from '../../assets/lotties/token-machine.json'

const localization = getLocale()

export const LandingPage = ({ protocolRef, allowListRef }) => {

  return (
    <Container id='landing-page'>
      <CoinPipe
        pathMobile={[
          { x: 240, y: 1544 },
          { x: 356, y: 1614 },
          { x: 90, y: 1774 },
          { x: 236, y: 1866 },
          { x: 30, y: 1990 },
          { x: 356, y: 2190 },
          { x: 150, y: 2314 },
          { x: 326, y: 2424 },
          { x: 58, y: 2584 },
          { x: 326, y: 2744 },
          { x: 90, y: 2890 },
          { x: 356, y: 3052 },
          { x: 120, y: 3194 },
          { x: 356, y: 3344 },
          { x: 120, y: 3484 },
          { x: 266, y: 3580 },
          { x: 30, y: 3714 },
          { x: 206, y: 3824 },
          { x: 90, y: 3894 },
          { x: 326, y: 4042 },
          { x: 60, y: 4202 },
          { x: 298, y: 4350 },
          { x: 60, y: 4494 },
          { x: 386, y: 4688 },
          { x: 240, y: 4780 },
          { x: 356, y: 4854 },
          { x: 60, y: 5034 },
          { x: 176, y: 5104 },
          { x: 90, y: 5158 },
          { x: 296, y: 5284 },
          { x: 90, y: 5408 },
          { x: 326, y: 5554 },
          { x: 150, y: 5660 },
        ]}
        pathDesktop={[
          { x: 750, y: 1240 },
          { x: 180, y: 1580 },
          { x: 750, y: 1920 },
          { x: 30, y: 2360 },
          { x: 870, y: 2860 },
          { x: 184, y: 3274 },
          { x: 840, y: 3670 },
          { x: 214, y: 4046 },
        ]}
      />

      <Opening protocolRef={protocolRef} />
      <Ecosystem />
      <Interoperability />
      <MeetBuildersTinyTap />
      <PublisherNFTs />
      <Mocaverse />
      <Gems />
      <BuildCampus />
      <CommunityCenter allowListRef={allowListRef} />
    </Container>
  )
}

const Opening = (props) => {
  const sendNotificationEmail = async (email) => {
    return await subscribeUserEmail(email)
  }

  return (
    <div className='relative-container'>
      <div className='center'>
        <img className='opencampus-img' alt="" />
        <h2 className="center-text main-title">{localization.communitiesShapeWorldtTroughEducation}</h2>
        <PlatformsIcons />

        <SingleInput
          buttonText={localization.getNotified}
          placeholder={localization.enterEmail}
          onSubmit={sendNotificationEmail}
          onSuccessText={localization.thanksForSubscribing}
        />

        <div className="protocol" ref={props.protocolRef}>
          <h2>{localization.theEduProtocol}</h2>
          <div className="center-text">{localization.theEduProtocolDescription}</div>
        </div>
        <InvestorsLogos />
        <div className='protocol-machine-container'>
          <LottieLoader animationData={protocolMachine} />
        </div>
      </div>
    </div>
  )
}
const Ecosystem = () => {
  return (
    <div className='relative-container'>
      <div className="ecosystem">
        <h2 className="sub-title">{localization.ecosystem}</h2>
        <div>
          {getBoldTexts(localization.ecosystemDescription).map((data, i) => {
            if (data.bold) {
              return <strong key={i}>{data.text}</strong>
            } else {
              return data.text
            }
          })}
        </div>
      </div>
    </div>
  )
}

const Interoperability = () => {
  return (
    <div className='relative-container'>
      <div className='token-machine-container'>
        <LottieLoader animationData={tokenMachine} startAnimationTopOffset={{ mobile: 146, desktop: 80 }} />
      </div>
      <div className="interoperability">
        <h2 className="sub-title">{localization.interoperability}</h2>
        <div>{localization.interoperabilityDescription}</div>
      </div>

      <div className='center'>
        <img className='coin' alt="" src={CoinImage} />
      </div>
    </div>
  )
}

const MeetBuildersTinyTap = () => {
  return (
    <>
      <div className='center'>
        <img className='meet-the-builders' alt="" src={MeetTheBuildersImage} />
      </div>
      <div className='relative-container'>
        <div className='tinytap-flag' />
        <div className='tinytap-campus-container'>
          <LottieLoader animationData={tinytapCampus} startAnimationTopOffset={{ mobile: 110, desktop: 50 }} />
        </div>
        <div className="tinytap-des">
          <div>
            {localization.tinytapDescription}
            {'\n\n\n'}
            {localization.tinytapDescriptionList.map((s, i) => {
              return <li key={`interoperability_item_${i}`}>{s}</li>
            })}
          </div>
        </div>
        <div className='books-faire-container'>
          <LottieLoader animationData={booksFaire} startAnimationTopOffset={{ mobile: 50, desktop: 26 }} />
        </div>
      </div>
    </>
  )
}

const PublisherNFTs = () => {
  return (
    <div className='relative-container'>
      <div className="publisher-nfts">
        <h2 className="sub-title">{localization.publisherNfts}</h2>
        <div>
          {localization.publisherNftsDescription} {localization.findOutMoreOn}{' '}
          <a href={`//${WEB3_TT_COM}`} rel="noreferrer" target="_blank">
            {WEB3_TT_COM}
          </a>
        </div>
      </div>
      <div className='nft-hologram-container'>
        <LottieLoader animationData={nftHologram} startAnimationTopOffset={{ mobile: 270, desktop: 246 }} />
      </div>
    </div>
  )
}

const Mocaverse = () => {
  return (
    <div className='relative-container'>
      <div className='mocaverse-portal-container'>
        <LottieLoader animationData={mocaversePortal} startAnimationTopOffset={{ mobile: 100, desktop: 126 }} />
      </div>
      <div className="mocaverse-flag" />
      <div className="mocaverse-des">
        <div>{localization.mocaverseDescription}</div>
      </div>
    </div>
  )
}

const Gems = () => {
  return (
    <div className='relative-container'>
      <div className="gems-flag" />
      <div className="gems-campus-container">
        <LottieLoader animationData={gemsCampus} startAnimationTopOffset={{ mobile: 96, desktop: 126 }} />
      </div>
      <div className="gems-des">
        <div>{localization.gemsDescription}</div>
      </div>
    </div>
  )
}

const BuildCampus = () => {
  return (
    <div className='relative-container'>
      <img className='build-campus-img' alt="" src={BuildCampusImage} />
      <div className='center'>
        <div className="build-campus">
          <h2>{localization.buildTheCampus}</h2>
          <div>
            {localization.buildTheCampusDescription} {localization.emailUs}{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>
        </div>
      </div>
    </div>
  )
}

const CommunityCenter = (props) => {
  return (
    <>
      <div className='relative-container' ref={props.allowListRef}>
        <div className='center'>
          <img className='launch-partners' alt="" src={LaunchPartnersImage} />
          <div className='launch-partners-row'>
            <div className="launch-inner-row">
              <img className='mocaverse-logo' alt="" src={MocaverseLogo} />
              <img className='sandbox-logo' alt="" src={SandboxLogo} />
            </div>
            <div className="launch-inner-row">
              <img className='animoca-logo' alt="" src={AnimocaLogo} />
              <img className='gems-logo' alt="" src={GemsLogo} />
              <img className='tiny-logo' alt="" src={TinyLogo} />
              {/* <BinaceLogo alt="" src={BinaceLogo} /> */}
            </div>
            <div className="launch-inner-row">
              <img className='hooked-logo' alt="" />
              <img className='highstreet-logo' alt="" src={HighstreetLogo} />
            </div>
          </div>
        </div>
      </div>
      <div className='relative-container'>
        <div className="community-center">
          <h2>{localization.communityCenter}</h2>
          <div className='text-container'>{localization.communityCenterDescription}</div>
          <div className='center'>
            <PlatformsIcons size="big" />
          </div>
        </div>
        <img className='community-center-img' alt="" src={CommunityCenterImage} />
      </div>
    </>
  )
}

